import { Phone, Send } from "lucide-react";
import React, { useEffect, useState } from "react";

interface Props {
    phoneUser: {
        phone_number: string,
        country_code : string
    };
    handleBack: (page: string) => void
    resend: () => void
}

const HandleReset: React.FC<Props> = ({handleBack, resend, phoneUser}) => {
  const [counter, setCounter] = useState(60);

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleResend = () => {
    if (counter === 0) {
        resend()
        setCounter(60);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-6 py-10 text-center">
      <div className="absolute top-16 left-4 text-2xl" onClick={()=>handleBack("phone")}>
        ←
      </div>
      <div className="items-center justify-center mt-10 bg-gray-100 rounded-full p-2">
        <Send className="w-16 h-16 p-2 grayscale opacity-20" />
      </div>
      <h2 className="text-sm font-semibold mb-2 mt-2">카카오톡 또는 문자로 전송되었습니다.</h2>
      <p className="text-sm text-gray-600 mb-1">
      링크를 확인해주세요
      </p>
      <p className="text-sm font-medium text-gray-800 mb-2">{phoneUser.phone_number}</p>
      <p className="text-sm text-gray-500 mb-6 px-6">
        감사합니다.
      </p>
      <button
        onClick={handleResend}
        disabled={counter > 0}
        className={`w-full max-w-xs py-2 rounded-full text-sm ${
          counter > 0 ? "bg-gray-200 text-gray-500" : "bg-blue-500 text-white"
        }`}
      >
        Resend {counter > 0 ? `(${counter}s)` : ""}
      </button>
    </div>
  );
};

export default HandleReset;
